import IncodeFaceAuth from "./components/IncodeLivenessComponent";

const INCODE_SDK_VERSION = '1.87.0';

interface IncodeLivenessProps {
    livenessSessionId: string;
    sessionId: string;
    sessionToken: string;
    interviewId: string;
    apiUrl: string;
    // Which Incode integration to use: '1' (default) for the legacy script-tag
    // SDK, '2' for the npm-based Web SDK 2.0 engine. Backend-controlled via
    // vendor_data.sdk_version, unrelated to sdkVersion below (the 1.x build).
    engineVersion?: string;
    onConnectionError?: () => void;
}

export default function IncodeLiveness({ livenessSessionId, sessionId, sessionToken, interviewId, apiUrl, engineVersion = '1', onConnectionError }: IncodeLivenessProps) {
    return (
        <IncodeFaceAuth
            apiUrl={apiUrl}
            identityId={sessionId}
            sessionToken={sessionToken}
            interviewId={interviewId}
            livenessSessionId={livenessSessionId}
            sdkVersion={INCODE_SDK_VERSION}
            engineVersion={engineVersion}
            onConnectionError={onConnectionError}
        />
    )
}
